/**
 * Define globally useful constants here
 * import individually to other files
 */
export const
  $document = $(document),
  $window = $(window),
  $body = $('body');

export const Breakpoints = {
  xsmall: 500,
  medium: 640,
  xmedium: 800,
  large: 1024,
  xlarge: 1200,
  xxlarge: 1440
};
